(() => {
  if (customElements.get('bs-video')) return;

  class BullseatVideo extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      const button = this.querySelector('[data-bs-video-load]');
      if (button) button.hidden = false;
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      if (event.target.closest('[data-bs-video-load]')) this.loadVideo();
      if (event.target.closest('[data-bs-video-unload]')) this.unloadVideo();
    }

    loadVideo() {
      const id = this.dataset.videoId;
      if (!['uglM-6Lb0LQ', 'U9O47yyOYEM'].includes(id)) return;
      const stage = this.querySelector('[data-bs-video-stage]');
      const poster = this.querySelector('[data-bs-video-poster]');
      if (!stage || !poster || stage.querySelector('iframe')) return;

      const frame = document.createElement('iframe');
      frame.className = 'bs-video__iframe';
      frame.title = this.dataset.videoTitle || 'Montageanleitung';
      frame.allow = 'encrypted-media; picture-in-picture; fullscreen';
      frame.setAttribute('allowfullscreen', '');
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.src = `https://www.youtube-nocookie.com/embed/${id}?rel=0`;
      poster.hidden = true;
      stage.append(frame);
      this.querySelector('[data-bs-video-unload]').hidden = false;
      this.querySelector('[data-bs-video-status]').textContent = 'YouTube-Video geladen. Starte die Wiedergabe im Player.';
      frame.focus();
    }

    unloadVideo() {
      this.querySelector('iframe')?.remove();
      const poster = this.querySelector('[data-bs-video-poster]');
      if (poster) poster.hidden = false;
      this.querySelector('[data-bs-video-unload]').hidden = true;
      this.querySelector('[data-bs-video-status]').textContent = 'Video entfernt. Du kannst es bei Bedarf erneut laden.';
      this.querySelector('[data-bs-video-load]')?.focus();
    }
  }

  customElements.define('bs-video', BullseatVideo);
})();
